<template>
    <div data-backdrop="static" data-keyboard="false" class="modal fade" id="carrier-tax-form-modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title page-title" v-html="modalTitle"/>
                </div>
                <form @submit.prevent="submit()" class="form-horizontal">
                    <div class="modal-body">
                        <div class="form-group row">
                            <label for="name" class="col-6 control-label">
                                <span v-html="$t('CarrierTaxFormModal.name')"/>
                                <RedAsterisk/>
                            </label>
                            <label for="percent" class="col-6 control-label">
                                <span v-html="$t('CarrierTaxFormModal.percent')"/>
                                <RedAsterisk/>
                            </label>
                            <div class="col-6">
                                <input id="name" :placeholder="$t('CarrierTaxFormModal.required')" type="text" class="form-control"
                                       required ref="nameInput" v-model="carrierTax.name"/>
                            </div>
                            <div class="col-6">
                                <div class="input-group">
                                    <input id="percent" step="0.01" min="0.01" max="100" required
                                           :placeholder="$t('CarrierTaxFormModal.required')"
                                           type="number" class="form-control" v-model="carrierTax.percent"/>
                                    <div class="input-group-append">
                                        <span class="input-group-text" v-html="'%'"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="name" class="col-12 control-label">
                                <span v-html="$t('CarrierTaxFormModal.deliveryCountry')"/>
                                <RedAsterisk/>
                            </label>
                            <div class="col-12">
                                <CountrySelect :clearable="false" :required="true"
                                               :selected-country-alpha3="carrierTax.country.alpha3ISO"
                                                @setSelectedCountry="setSelectedCountry"/>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer flex justify-content-between">
                        <button :disabled="loading" type="button" class="btn btn-secondary" data-dismiss="modal"
                                v-html="$t('CarrierTaxFormModal.close')"/>
                        <SubmitBtn classes="btn btn-primary" :text="modalMainAction" :loading="loading"/>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import SubmitBtn from "../../../../shared/forms/SubmitBtn";
import CarrierTax from "../../../../../classes/Billing/Carrier/CarrierTax";
import RedAsterisk from "../../../../shared/forms/RedAsterisk";
import CountrySelect from "../../../../shared/forms/CountrySelect";

export default {
    name: "CarrierTaxFormModal",
    components: {CountrySelect, RedAsterisk, SubmitBtn },
    props: {
        carrier: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            carrierTax: new CarrierTax(),
            mode: "create",
        };
    },
    computed: {
        ...mapGetters("countries", {
            countries: "countries",
        }),
        modalTitle() {
            return this.mode === "create" ? this.$t("CarrierTaxFormModal.addCarrierTax") : this.$t("CarrierTaxFormModal.editCarrierTax");
        },
        modalMainAction() {
            return this.mode === "create" ? this.$t("CarrierTaxFormModal.add") : this.$t("CarrierTaxFormModal.edit");
        },
    },
    methods: {
        show(carrierTax = null) {
            this.mode = carrierTax === null ? "create" : "edit";
            this.carrierTax = new CarrierTax(carrierTax);
            if (this.mode === "create") {
                setTimeout(() => this.$refs.nameInput.focus(), 500);
            }
            // eslint-disable-next-line no-undef
            $("#carrier-tax-form-modal").modal("show");
        },
        async submit() {
            this.carrierTax.carrierId = this.carrier.id;
            try {
                this.loading = true;
                if (this.mode === "create") {
                    await this.submitCreate();
                } else if (this.mode === "edit") {
                    await this.submitEdit();
                }
            } catch (e) {
                this.$displayError(e);
            } finally {
                this.loading = false;
            }
        },
        setSelectedCountry(country) {
            this.carrierTax.deliveryCountryId = !country ? undefined : country.id;
            this.carrierTax.country.alpha3ISO = !country ? undefined : country.alpha3ISO;
        },
        async submitCreate() {
            const response = await this.$diceAPI.postCarrierTax(this.carrierTax);
            this.$emit("addCarrierTax", response.data);
            // eslint-disable-next-line no-undef
            $("#carrier-tax-form-modal").modal("hide");
            this.$toasted.success(this.$t("CarrierTaxFormModal.carrierTaxAdded"), { icon: "check" });
        },
        async submitEdit() {
            const response = await this.$diceAPI.patchCarrierTax(this.carrierTax);
            this.$emit("editCarrierTax", response.data);
            // eslint-disable-next-line no-undef
            $("#carrier-tax-form-modal").modal("hide");
            this.$toasted.success(this.$t("CarrierTaxFormModal.carrierTaxEdited"), { icon: "check" });
        },
    },
};
</script>

<style scoped>

</style>